(function () {
  angular.module("akitabox.ui.dialogs.note.delete", [
    "akitabox.core.constants",
    "akitabox.core.services.note",
    "akitabox.core.toast",
  ]);
})();
